/**
 * Unsupported / SpecOnly — the FAIL-CLOSED markers (README §7.6).
 *
 * A page never renders half-known: an unknown component type, an unknown
 * selector op or an unknown named derive renders a VISIBLE marker naming what
 * was missing, and the runtime reports it up to the studio. Silently dropping
 * the node is the failure mode this exists to prevent.
 *
 * `SpecOnly` is the different, honest case: the component IS in the registry
 * but carries `render: "spec"` — documented contract, no native impl yet. It
 * draws a dashed host-chrome outline so the preview shows where the real
 * affordance sits without pretending to be it.
 */

export function UnsupportedComponent({ what = 'component', name, detail }) {
  return (
    <div
      role="note"
      style={{
        border: '1px dashed var(--bad)',
        background: 'var(--bad-soft)',
        color: 'var(--bad)',
        borderRadius: 'var(--r-sm)',
        padding: 'var(--sp-3)',
        fontSize: 'var(--t-xs)',
        fontFamily: 'var(--font-mono)',
        lineHeight: 1.4,
      }}
    >
      <strong style={{ display: 'block', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        unsupported {what}
      </strong>
      {name ? <span>{name}</span> : null}
      {detail ? <div style={{ opacity: 0.8, marginTop: 2 }}>{detail}</div> : null}
    </div>
  );
}

export function SpecOnly({ name, note }) {
  return (
    <div
      role="note"
      style={{
        border: '1px dashed var(--line)',
        color: 'var(--text-3)',
        borderRadius: 'var(--r-pill)',
        padding: '6px var(--sp-3)',
        fontSize: 'var(--t-xs)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        alignSelf: 'flex-start',
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: 3, background: 'var(--line)' }} />
      {name} · {note || 'host-owned chrome (spec)'}
    </div>
  );
}
